module.exports = __webpack_public_path__ + "6157c663d5be19d5b4165434f6dd2cff.svg";